import { BaseNode } from 'helpers/documents/types/base';
import { useMemo, useState } from 'react';
import { SelectionStore } from './SelectionStore';

export const useSelectMode = (items: BaseNode[]) => {
  const [isSelectMode, setIsSelectMode] = useState(false);

  const store = useMemo(
    () => new SelectionStore(items),
    [items.toString(), isSelectMode],
  );

  return { store, isSelectMode, setIsSelectMode };
};
